export const mutations = {
    set_obj_solicitud_descuento(state, data) {
        state.obj_solicitud_descuento = data
    },
    set_obj_detalle_descuento(state, data) {
        state.obj_detalle_descuento = data
    },
    set_datos_cliente(state, data) {
        state.datos_cliente = data
    },
    set_forma_de_pago(state, data) {
        state.forma_de_pago = data
    },
    set_carrito_facturador(state, data) {
        state.carrito_facturador = data
    },
    set_datos_anticipo_modal(state, data) {
        state.datos_anticipo_modal = data
    },
    set_datos_anticipo_completo(state, data) {
        state.datos_anticipo_completo = data
    }
}
